import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PathParseService } from './providers/path-parse.service';

const COMPONENTS : any = [];
const IMPORTS = [
  CommonModule
];
const PROVIDERS = [
  PathParseService,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...IMPORTS],
  providers: [...PROVIDERS],
  exports: [...COMPONENTS]
})
export class CoreModule { }
